import styled from "styled-components";

export const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const MiddleGroup = styled.div`
  display: flex;
  gap: 1rem;
`;

export const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 0.25rem;
  margin-right: 0.5rem;
`;

export const ProgressBar = styled.progress`
  margin: 0;
`;
